import {Injectable, signal} from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class MediaStore {
  private _images = signal<any>([]);
  private _showMediaLib = signal<boolean>(false);
  private _selectOnDoubleClick = signal<boolean>(true);
  private _showSizes = signal<boolean>(true);
  private _size = signal<any>(null);
  private _formats = signal<any>([]);
  private _onCreate = signal<any>(null);
  private _getVideoSource = signal<any>(null);
  private _progressVideoUpload = signal<any>(0);
  private _uploadingProcess = signal<boolean>(false);


  public setImageResource: any;

  constructor() {
  }

  get images(){
    return this._images();
  }

  set images(value: any) {
    this._images.set(value);
  }

  get showMediaLib(){
    return this._showMediaLib();
  }

  set progressVideoUpload(value: any) {
    this._progressVideoUpload.set(value);
  }

  get progressVideoUpload(){
    return this._progressVideoUpload();
  }

  set showMediaLib(value: any) {
    this._showMediaLib.set(value);
  }

  set onCreate(value: any){
    this._onCreate.set(value);
  }

  get onCreate(){
    return this._onCreate();
  }

  set getVideoSource(value: any){
    this._getVideoSource.set(value);
  }

  get getVideoSource(){
    return this._getVideoSource();
  }


  get selectOnDoubleClick(){
    return this._selectOnDoubleClick();
  }

  set selectOnDoubleClick(value: boolean) {
    this._selectOnDoubleClick.set(value);
  }

  get showSizes(){
    return this._showSizes();
  }

  set showSizes(value: boolean) {
    this._showSizes.set(value);
  }

  get size(){
    return this._size();
  }

  set size(value: any) {
    this._size.set(value);
  }

  set formats(value){
    this._formats.set(value);
  }

  get formats(){
    return this._formats();
  }

  set uploadingProcess(value){
    this._uploadingProcess.set(value);
  }

  get uploadingProcess(){
    return this._uploadingProcess();
  }

}